var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.authenticated)?_c('NavigationBar'):_vm._e(),_c('v-main',[_c('KeepAlive',{attrs:{"exclude":"SingleMandoob"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }